export const QUERY_PARAM = 'date'
